import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form, Input, Select } from "antd";
import FormItem from "components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";
import TextArea from "antd/es/input/TextArea";
import CrudButtons from "components/button/crudbuttons";
import { 
    Send,
} from "lucide-react";
import {
    getTicketDetails,
    doTicketCreate,
} from "../../../../../../redux/supportticket/supportticketState";
import { DEPARTMENT_ICONS } from "variables/constants";
 
const MessageTicket = ({
    onCancel,
    getRecord,
    recordData, 
	requesting, 
	success,
    doCreate, 
	doUpdate, 
    ...props
}) => {
    const { recordId, mode } = props;
    const [form] = Form.useForm();

    useEffect(() => {
        getRecord(recordId);
    }, [getRecord, recordId]);

    const onSubmit = (formData) => {
        try {
            formData.is_message = 0;

            recordData.tic_id > 0 ? doUpdate(formData): doCreate(formData); 
        } catch (error) {
            console.error('Save failed:', error);
        }
    };

    const priorityLabelMap = {
        Low: "Low - General inquiry",
        Medium: "Medium - Standard request",
        High: "High - Urgent issue",
    };

    const modifiedPriorityOptions = (recordData?.priority || []).map(item => ({
        ...item,
        label: priorityLabelMap[item.label] || item.label,
    }));


    const modifiedDepartmentOptions = (recordData?.ticDepartment || []).map(item => {
        const IconComponent = DEPARTMENT_ICONS[item.label]; 
        return {
            ...item,
            label: (
            <div className="flex items-center gap-2">
                {IconComponent && <IconComponent className="w-4 h-4 text-slate-700" />}
                <span>{item.label}</span>
            </div>
            ),
        };
    });


    return (
        <Card className="p-0">
            <Form
                form={form}
                className={mode !== "view" ? "form" : ""}
                layout="vertical" 
                onFinish={onSubmit}
            >
                <div className="space-y-2">
                    <div className="space-y-2">
                        <FormItem
                            label="Department"
                            name="tic_department_id"
                            rules={[requiredField()]}
                        >
                            <Select
                                id="tic_department_id"    
                                placeholder="Select department"
                                options={modifiedDepartmentOptions}
                                showLabel={true}
                                allowClear={true}
                                className="input-field"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_priority_id" 
                            label="Priority"
                            rules={[requiredField()]}
                        >
                            <Select id="tic_priority_id"
                                allowClear={true}
                                className="input-field"
                                options={modifiedPriorityOptions}
                                placeholder="Select priority"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_title" 
                            label="Subject"
                            rules={[requiredField()]}
                        >
                            <Input id="tic_title"
                                allowClear={true}
                                className="input-field"
                                placeholder="Brief description of your inquiry"
                            />
                        </FormItem>
                        <FormItem
                            name="tic_description"
                            label="Details"
                            rules={[requiredField()]}
                        >
                            <TextArea
                                id="tic_description" 
                                className="input-field"
                                maxLength={255}
                                placeholder="Provide details about your request..."
                                rows={3}
                            />
                        </FormItem>
                    </div>
                    <div className="flex gap-2 justify-end">
                        <CrudButtons
                            mode={mode}
                            recordId={recordData?.tic_id ?? 0}
                            isModal={true}
                            modalId={recordData?.tic_id > 0 ? "edit_ticket" : "add_ticket"}
                            doHideModal={onCancel}
                            cancelLabel="Cancel"
                            submitLabel="Send Message"
                            moduleId={0}
                            cancelIcon=""
                            submitIcon={<Send className="w-4 h-4 mr-2" />}
                            submitClassName="ticket submit-ticket emerald"
                            cancelClassName="ticket cancel-ticket"
                        />
                    </div>
                </div>
            </Form>
        </Card>
    )
};
const mapStateToProps = (state) => ({
    recordData: state.ticket.ticketDetails?.data,
    requesting: state.ticket.ticketDetails?.requesting,
    success: state.ticket.ticketDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
    getRecord: (id) => dispatch(getTicketDetails(id)),
    doCreate: (data) => dispatch(doTicketCreate(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MessageTicket);